import { JDSSearchResultsInternalProps } from './generated/interface';

export const withLogic =
  (
    Component: React.ComponentType<JDSSearchResultsInternalProps>
  ): React.FC<JDSSearchResultsInternalProps> =>
  (props: JDSSearchResultsInternalProps) => {
    return <Component {...props} />;
  };
